import axios from "axios";
import router from "@/router"
import {Storage} from "@/Services/Storage";
import {errorHandler} from "../../Services/errorHandler";


export default {
    name: 'payment_requests',
    state: {},
    getters: {},
    mutations: {},
    actions: {
        makeExpenseRequest: async (context, formData) => {
            let user = await Storage.getCurrentUser();
            formData.user = user.Username;
            return axios.post(paymentApi + `makeRequest`, formData)
        },

        getAllPendingRequests: async (context, searchQuery) => {
            let user = await Storage.getCurrentUser();
            let obj = searchQuery
            obj.userType = user.Type;
            return axios.get(paymentApi + `getAllPendingRequests`, {
                params: obj
            }).then(({data}) => data).catch(err => errorHandler.tomcatError(err))
        },
        getUserHistory: async (context, searchQuery) => {
            let user = await Storage.getCurrentUser();
            let obj = searchQuery
            obj.currentUser = user.Username;
            return axios.post(paymentApi + `searchHistory`, obj)
                .then(({data}) => data).catch(err => errorHandler.tomcatError(err))
        },
        authorizeRequest: async (context, payload) => {
            let user = await Storage.getCurrentUser();
            let obj = {
                id: payload.id,
                authorizedBy : user.Username,
                method : payload.method,
            };
            return axios.post(paymentApi + `authorizeRequest`, obj)
                .catch(err => errorHandler.tomcatError(err))
        },
        denyRequest: async (context, obj) => {
            let user = await Storage.getCurrentUser();
             obj = {
                denyReason : obj.denyReason,
                deniedBy : user.Username,
                id : obj.id,
            };
            return axios.post(paymentApi + `denyRequest`, obj)
                .catch(err => errorHandler.tomcatError(err))
        }


    }
}

